




























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { debounce, Cancelable } from 'lodash';

import { ContextsState, UserState } from '@/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { CONTRACTS, FetchServiceContract } from '@/core/contracts';

interface IContextSettingsModel {
    contextType: string;
    currentTime: string;
    scheduleTime: string;
    settings: { [key: string]: string };
}

@Component({})
export default class ContextSettingsContextComponent extends Vue {
    public inLoading: boolean = false;
    public settings?: IContextSettingsModel;
    public contextName: string = '';

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    private typeWasChanged?: (() => void) & Cancelable = undefined;

    public created() {
        const delay = 2000;
        this.typeWasChanged = debounce(
            this.saveChangesOnServer.bind(this),
            delay
        );
        this.loadSettings();
    }

    public get contextNameChanged(): boolean {
        return this.contextName !== null
            && this.contextName.trim() !== ''
            && ContextsState.current!.name !== this.contextName;
    }

    public get userIsAdministrator(): boolean {
        return ContextsState.current!.own === true;
    }

    public changeContextName() {
        if (this.contextName !== null) {
            ContextsState.changeContextName({
                id: ContextsState.current!.id,
                name: this.contextName
            });
        }
    }

    private async loadSettings(): Promise<void> {
        this.inLoading = true;
        try {
            const currentContextId = ContextsState.currentContextId;

            const loadedSettings = await this._fetchService!
                .get<IContextSettingsModel>('/contexts/' + currentContextId + '/settings');

            this.settings = loadedSettings;
            this.contextName = ContextsState.current!.name;
        } finally {
            this.inLoading = false;
        }
    }

    private async saveChangesOnServer(): Promise<void> {
        this.inLoading = true;
        try {
            const currentContextId = ContextsState.currentContextId;
            await this._fetchService!.put(
                '/contexts/' + currentContextId + '/settings',
                this.settings
            );
            this.loadSettings();
        } finally {
            this.inLoading = false;
        }
    }
}
